import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6c537535"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "预约产品解决方案演示", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip"
}, "感谢您的关注！我们的工作人员将于24h内与您联系~", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_textarea = _resolveComponent("a-textarea");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[4] || (_cache[4] = $event => _ctx.visible = $event),
    wrapClassName: "warp-container",
    width: _ctx.width,
    footer: null,
    destroyOnClose: "",
    "after-close": _ctx.afterCloseHandle,
    bodyStyle: _ctx.bodyStyle
  }, {
    title: _withCtx(() => [_hoisted_1]),
    default: _withCtx(() => [_hoisted_2, _createVNode(_component_a_form, {
      ref: "formRef",
      layout: "vertical",
      hideRequiredMark: "",
      model: _ctx.formState,
      labelAlign: "left",
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [_createVNode(_component_a_form_item, {
        label: "姓名",
        name: "name"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          size: "large",
          value: _ctx.formState.name,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => _ctx.formState.name = $event),
          maxlength: 20,
          placeholder: "您的姓名..."
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "手机号",
        name: "phone"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          size: "large",
          value: _ctx.formState.phone,
          "onUpdate:value": _cache[1] || (_cache[1] = $event => _ctx.formState.phone = $event),
          maxlength: 11,
          placeholder: "请输入正确的手机号..."
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "企业/单位名称",
        name: "companyName"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_input, {
          value: _ctx.formState.companyName,
          "onUpdate:value": _cache[2] || (_cache[2] = $event => _ctx.formState.companyName = $event),
          size: "large",
          maxlength: 100,
          placeholder: "请输入公司名称..."
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_a_form_item, {
        label: "如果如果您有其他信息咨询或疑问，欢迎留言（选填）",
        name: "remark"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_textarea, {
          maxlength: 300,
          value: _ctx.formState.remark,
          "onUpdate:value": _cache[3] || (_cache[3] = $event => _ctx.formState.remark = $event),
          placeholder: "请留言...",
          rows: 4
        }, null, 8, ["value"])]),
        _: 1
      }), _createVNode(_component_a_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_a_button, {
          type: "primary",
          size: "large",
          block: "",
          class: "btn",
          onClick: _ctx.submitHandle
        }, {
          default: _withCtx(() => [_createTextVNode("立即预约")]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["visible", "width", "after-close", "bodyStyle"]);
}